import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const serviceName = 'traffic-fine-service';

export const GetUserTrafficDetails = createAsyncThunk(
    'traffic/GetUserTrafficDetails ',
    async (userId, { dispatch, getState }) => {
        const response = await apiInstance
            .get(`${serviceName}/v1/user/${userId}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

export const GetFinesTrafficDetails = createAsyncThunk(
    'traffic/GetFinesTrafficDetails',
    async (fineId, { dispatch, getState }) => {
        const response = await apiInstance
            .get(`${serviceName}/v1/${fineId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = response;

        return { data, status };
    },
);
export const GetEvidencesList = createAsyncThunk('traffic/GetEvidencesList', async (fineId, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/evidences/${fineId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
export const GetAllGeofenceList = createAsyncThunk('traffic/GetAllGeofenceList ', async () => {
      const result = await apiInstance
        .get(`${serviceName}/v1/geofences/get-all`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const RegisterFinePaid = createAsyncThunk("traffic/RegisterFinePaid",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${serviceName}/v1/payments/update`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const CreatePaymentEvidence = createAsyncThunk("traffic/CreatePaymentEvidence",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`${serviceName}/v1/payments-evidence/create`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetPaymentEvidence = createAsyncThunk("traffic/GetPaymentEvidence",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(`${serviceName}/v1/payments-evidence/fine-payment-id/${params}`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

